export enum TipoCorteServicio {
  DEFAULT = '',
  NORMAL = 'N',
  CORTADO = 'C',
  REPOSICION = 'R',
  TRAMITE_CORTE = 'T',
}
